"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_tag_autocomplete_1 = __importDefault(require("react-tag-autocomplete"));
const react_i18next_1 = require("react-i18next");
const functions_1 = require("@/common/functions");
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const tags = (0, react_redux_1.useSelector)((state) => state.roomData.tag).map((item, index) => {
        return { id: index, name: item };
    });
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const nameInput = (0, react_1.useRef)(null);
    const focusAfterClick = () => {
        const inputElement = document.getElementsByClassName('react-tags__search-input')[0];
        if (nameInput.current) {
            inputElement.blur();
            nameInput.current.focus();
            inputElement.focus();
        }
    };
    const addHashTag = (e) => {
        if (e.code === 'Enter' || e.code === 'Tab' || e.code === 'Space') {
            if (!e.nativeEvent.isComposing) {
                e.preventDefault();
                focusAfterClick();
            }
        }
    };
    const validateTag = (e) => {
        if (tags.length > 4) {
            (0, functions_1.showToastMessage)({ message: t('최대 5개까지 추가할 수 있어요') });
        }
        else {
            if (e.name.includes('#')) {
                let tag = e.name.split('#');
                if (tag.length < 6) {
                    for (let i = 0; i < tag.length; i++) {
                        if (tag[i].length > 0) {
                            dispatch((0, roomCreateStore_1.addRoomTag)(tag[i].replace(/(\s*)/g, '')));
                        }
                    }
                }
                else {
                    for (let i = 0; i < 5; i++) {
                        if (tag[i].length > 0) {
                            dispatch((0, roomCreateStore_1.addRoomTag)(tag[i].replace(/(\s*)/g, '')));
                            (0, functions_1.showToastMessage)({ message: t('최대 5개까지 추가할 수 있어요') });
                        }
                    }
                }
            }
            else {
                const tagName = e.name.replace(/(\s*)/g, '');
                dispatch((0, roomCreateStore_1.addRoomTag)(tagName));
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(TagsDiv, Object.assign({ onKeyDown: e => {
                addHashTag(e);
            }, notFocusWithinWord: `#${t('태그')}` }, { children: [(0, jsx_runtime_1.jsx)(react_tag_autocomplete_1.default, { tags: tags, onAddition: e => {
                        validateTag(e);
                    }, onDelete: e => dispatch((0, roomCreateStore_1.deleteRoomTag)(e)), addOnBlur: true, allowNew: true, minQueryLength: 1, delimiters: [], placeholderText: "\uB85C \uAC80\uC0C9\uC728\uC744 \uB192\uC5EC\uBCF4\uC138\uC694!", removeButtonText: "\uD074\uB9AD\uD558\uC5EC \uD0DC\uADF8 \uC0AD\uC81C" }), (0, jsx_runtime_1.jsx)(HiddenInput, { ref: nameInput }), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ id: "tag_btn", onClick: focusAfterClick }, { children: (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4" }, { children: ["+ ", t('추가')] })) }))] })) }));
}
exports.default = default_1;
// eslint-disable-next-line prettier/prettier
const TagsDiv = styled_1.default.div `
  position: relative;
  .react-tags {
    width: 100%;
    min-height: 48px;
    padding: 6px 12px;
    border: 1px solid var(--gray-10);
    border-radius: 8px;
    font-size: 15px;
    line-height: 1.2;
    cursor: text;
    &.is-focused {
      border: 1px solid var(--gray-60);
    }
  }
  .react-tags__selected {
    max-height: 70px;
    margin-right: 56px;
    overflow-y: auto;
  }
  .react-tags__selected-tag {
    &::before {
      content: '#';
    }
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    margin: 0 4px 4px 0;
    padding: 6px 10px;
    border: 0;
    border-radius: 100px;
    background: #f8f8f8;
    font-size: inherit;
    line-height: inherit;
    text-align: start;
    word-break: break-all;
    &::after {
      content: url('/static/react/src/assets/svgs/x_circle_gray.svg');
      width: 16px;
      height: 16px;
      margin-left: 8px;
      cursor: pointer;
    }
    &:focus {
      outline: 0 !important;
    }
  }
  .react-tags__search {
    max-width: 100%;
  }
  .react-tags__search-wrapper {
    margin-top: 5px;
    margin-right: 56px;
    &:focus-within::before {
      content: '#';
    }
    &:not(:focus-within)::before {
      content: '${props => props.notFocusWithinWord}';
    }
  }
  .react-tags__search input {
    max-width: 100%;
    height: 24px;
    margin: 0;
    padding: 0;
    border: 0;
    outline: none;
    font-size: inherit;
    line-height: inherit;
    color: rgba(0, 0, 0, 0.8);
    :focus::placeholder {
      color: transparent;
    }
  }
  .react-tags__search input::-ms-clear {
    display: none;
  }
  #tag_btn {
    position: absolute;
    top: 8px;
    right: 12px;
    min-width: 56px;
    height: 32px;
    padding: 0 12px;
    border: 1px solid rgba(0, 0, 0, 0.8);
    border-radius: 6px;
    background-color: white;
    color: rgba(0, 0, 0, 0.8);
  }
`;
const HiddenInput = styled_1.default.input `
  position: absolute;
  border: none;
  z-index: -1;
`;
